import { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";

function normalizeColor(color, fallback = "#ffffff") {
  if (typeof color !== "string") return fallback;
  let temp = color.trim();
  if (!temp.startsWith("#")) temp = `#${temp}`;
  if (temp.length !== 7 && temp.length !== 4) return fallback;
  return temp;
}

export default function NavbarClassic({ config, hideSidebar }) {
  const navColor = normalizeColor(config.navbar?.colornav, "#ffffff");
  const navTextColor = normalizeColor(config.navbar?.colornavtext, "#000000");
  const logoSrc = config.logo || config.pagerData?.logo || "";

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Navbar
      style={{ backgroundColor: navColor }}
      variant={config.navbar?.cor_texto ? "dark" : "light"}
      expand="lg"
      className="navbar-custom py-3 px-5"
    >
      <Container fluid className="px-4">
        {/* Logo à esquerda */}
        <Navbar.Brand className="d-flex align-items-center">
          {logoSrc && (
            <img
              src={logoSrc}
              alt="Logo"
              style={{
                maxWidth: "100px",
                maxHeight: "150px",
                objectFit: "contain",
              }}
            />
          )}
        </Navbar.Brand>

        {/* Toggle manual com ícone bootstrap-icons */}
        <button
          type="button"
          aria-label="Abrir menu"
          className="bg-transparent border-0 d-lg-none ms-auto"
          style={{ color: navTextColor, fontSize: "2rem", outline: "none" }}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <i className={menuOpen ? "bi bi-x-lg" : "bi bi-list"}></i>
        </button>

        <Navbar.Collapse id="navbar-content" in={menuOpen} className={menuOpen ? "show" : ""}>
          <div className="d-flex align-items-center justify-content-between w-100">
            {/* Menus centralizados */}
            <Nav
              className="mx-auto d-flex flex-row gap-4 fw-bold"
              style={{ fontFamily: "Axiforma, sans-serif", fontWeight: "bold" }}
            >
              {config.navbar?.nav_links?.map((link, index) => (
                <a
                  key={index}
                  href={
                    hideSidebar
                      ? `${window.location.pathname}#${link.toLowerCase()}`
                      : ""
                  }
                  style={{
                    color: navTextColor,
                    fontWeight: 500,
                    padding: "0.3rem 0.8rem",
                    fontFamily: "Axiforma, sans-serif",
                    textDecoration: "none",
                  }}
                  className="text-center position-relative"
                >
                  {link}
                </a>
              ))}
            </Nav>

            {/* Redes sociais à direita */}
            <Nav className="d-flex flex-row justify-content-end gap-3">
              {config.navbar?.link_instagram && (
                <Nav.Link
                  href={`https://www.instagram.com/${config.navbar.link_instagram.replace(
                    /^@/,
                    ""
                  )}`}
                  target="_blank"
                  style={{ color: navTextColor }}
                >
                  <i className="pi pi-instagram" style={{ fontSize: "1.4rem" }}></i>
                </Nav.Link>
              )}
              {config.navbar?.Tel_Site && (
                <Nav.Link
                  href={`https://wa.me/55${config.navbar.Tel_Site.replace(/\D/g, "")}`}
                  target="_blank"
                  style={{ color: navTextColor }}
                >
                  <i className="pi pi-whatsapp" style={{ fontSize: "1.4rem" }}></i>
                </Nav.Link>
              )}
            </Nav>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
